import React from 'react';
var ErrorPage = function () {
    return (React.createElement("div", { className: 'dark' },
        React.createElement("div", { className: 'bg-primary text-primary flex h-screen grow flex-col items-center justify-center p-4' },
            React.createElement("p", { className: 'text-xl' }, "An error has occurred. Please try later."),
            React.createElement("p", { className: 'text-secondary mt-2' },
                "If this persists, please contact us at:",
                ' ',
                React.createElement("a", { className: 'text-primary underline underline-offset-4', href: 'mailto:support@substratum.app' }, "support@substratum.app")))));
};
export default ErrorPage;
